<template>
  <a-form-model ref="form" :model="form" v-bind="$formItemLayout">
    <a-form-model-item
      label="员工名称："
      prop="username"
      :rules="{
        required: true,
        message: '请输入',
        trigger: 'blur',
      }"
    >
      <a-input v-model.trim="form.username" :maxLength="25" />
    </a-form-model-item>
    <a-form-model-item label="手机号：" prop="cellphone" :rules="checkPhoneRule">
      <a-input v-model.trim="form.cellphone" :maxLength="11" />
    </a-form-model-item>
    <a-form-model-item label="邮箱：" prop="email" :rules="checkEmail">
      <a-input v-model.trim="form.email" :maxLength="50" />
    </a-form-model-item>
    <!-- <a-form-model-item
      label="状态："
      :rules="{
        required: true,
        message: '请选择',
        trigger: 'blur'
      }"
      prop="status"
    >
      <a-radio-group v-model="form.status">
        <a-radio v-for="statusInfo in statusOptions" :key="statusInfo.value" :value="statusInfo.value">
          {{ statusInfo.label }}
        </a-radio>
      </a-radio-group>
    </a-form-model-item>-->
    <a-form-model-item
      label="所属机构："
      prop="mechanismId"
      :rules="{
        required: true,
        message: '请选择',
        trigger: 'blur',
      }"
    >
      <a-cascader
        :options="mechanismOptions"
        change-on-select
        v-model="defaultMechanism"
        @change="onChange"
        :fieldNames="{ label: 'name', value: 'id', children: 'childrenList' }"
        placeholder="请选择"
      ></a-cascader>
    </a-form-model-item>
    <a-form-model-item
      label="职位："
      prop="postId"
      :rules="{
        required: true,
        message: '请选择',
        trigger: 'blur',
      }"
      :style="isEdit ? 'margin-bottom: 64px' : ''"
    >
      <a-select :default-value="form.postId" v-model="form.postId" allowClear placeholder="请选择">
        <a-select-option v-for="postInfo in postOptions" :key="postInfo.id" :value="postInfo.id">
          {{
          postInfo.name
          }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <!-- 默认密码字段，只在新增模式下显示 -->
    <a-form-model-item
      v-if="!isEdit"
      label="默认密码："
      prop="password"
      :rules="checkPassword"
      style="margin-bottom: 64px"
      compact
    >
      <a-input-group compact>
        <a-input-password
          visibilityToggle
          v-model.trim="form.password"
          placeholder="请输入密码"
          style="width: calc(100% - 40px)"
          :maxLength="20"
          @blur="handlePasswordBlur"
          @input="handlePasswordInput"
        ></a-input-password>
        <a-button icon="reload" @click="genPwd" style="width: 40px" title="生成随机密码" />
      </a-input-group>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { cloneDeep } from 'lodash'
import { COMMON_STATUS } from '@/store/dictionary'
import * as postApi from '@/api/post'
import * as mechanismApi from '@/api/mechanism'
import * as userApi from '@/api/user'
export default {
  data() {
    const MobileNumberValidator = (rule, value, callback) => {
      const idcardReg = /^1(3|4|5|6|7|8|9)\d{9}$/
      if (!idcardReg.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入正确的手机号码')
      }
      callback()
    }
    // 邮箱验证
    const EmailValidator = (rule, value, callback) => {
      const idcardReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
      if (value && !idcardReg.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入正确格式的邮箱')
      }
      callback()
    }
    // 密码验证
    const PasswordValidator = (rule, value, callback) => {
      const idcardReg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/
      if (!idcardReg.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('密码必须8-16位至少包含大小字母数字特殊字符中的三种')
      }
      callback()
    }
    return {
      isEdit: false,
      checkPhoneRule: [
        { validator: MobileNumberValidator, max: 11, trigger: ['change', 'blur'] },
        {
          required: true,
          message: '请输入',
          trigger: ['change', 'blur'],
        },
      ],
      checkEmail: [
        { validator: EmailValidator, max: 50, trigger: ['change', 'blur'] },
        {
          message: '请输入',
          trigger: ['change', 'blur'],
        },
      ],
      checkPassword: [
        { validator: PasswordValidator, max: 50, trigger: ['change', 'blur'] },
        {
          required: true,
          message: '请输入或生成默认密码',
          trigger: ['change', 'blur'],
        },
      ],
      form: {
        username: '',
        cellphone: '',
        email: '',
        mechanismId: '',
        postId: '',
        status: 'AVAILABLE',
        password: '',
      },
      statusOptions: COMMON_STATUS,
      postOptions: [],
      mechanismOptions: [],
      defaultMechanism: [],
    }
  },
  mounted() {
    postApi.postOptions().then((res) => {
      this.postOptions = res.data
    })
    mechanismApi.mechanismOptions().then((res) => {
      this.mechanismOptions = res.data
    })
  },
  methods: {
    // 新增密码输入框事件处理
    handlePasswordBlur() {
      // 手动触发密码字段的验证
      this.$refs.form.validateField('password')
    },
    handlePasswordInput() {
      // 输入时也触发验证，确保实时验证
      this.$refs.form.validateField('password')
    },
    genPwd() {
      userApi
        .genPwd()
        .then((response) => {
          if (response.data) {
            this.form.password = response.data
            this.$message.success('密码已生成')
            // 生成密码后立即触发验证
            this.$nextTick(() => {
              this.$refs.form.validateField('password')
            })
          }
        })
        .catch((error) => {
          this.$message.error('生成密码失败')
          console.error('生成密码失败:', error)
        })
    },
    initData(form, defaultMechanism) {
      // 根据是否传入ID来判断是编辑模式还是新增模式
      this.isEdit = !!(form && form.id)
      this.form = Object.assign({}, this.form, form)
      if (defaultMechanism) {
        this.defaultMechanism = defaultMechanism
      }
    },
    validate() {
      const {
        $refs: { form },
      } = this
      return new Promise((resolve, reject) => {
        form.validate((valid, err) => {
          if (valid) {
            resolve(valid)
            return
          }
          reject(err)
        })
      })
    },
    formatForm() {
      try {
        const ret = cloneDeep(this.form)
        return { ...ret }
      } catch {}
    },
    onChange(record) {
      this.defaultMechanism = record
      this.$set(this.form, 'mechanismId', record[record.length - 1])
    },
  },
}
</script>

<style lang="less" scoped></style>
